export enum TokenType {
  API = "API",
  DEVICE = "DEVICE",
  RESET = "RESET"
}